import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TimeWorkedService {
  http: HttpClient;

  constructor(http: HttpClient) {
    this.http = http;
  }

  getCrewClockInStatus(pRPCKeyID, crewTemplateID) {
    const url = '/CrewTimecard/GetCrewClockInStatus?pRPCKeyID=' + pRPCKeyID + '&crewTemplateID=' + crewTemplateID;
    return this.http.get(url).toPromise();
  }

  getDailyTime(employee, pRPCKeyID, startDateString = null, endDateString = null, isStandardTimecard = false) {
    let url = '/Timecard/GetDailyTime?';
    if (isStandardTimecard) {
      url += 'pREHKeyID=' + employee;
    } else {
      url += 'employeeString=' + employee;
    }
    url += '&pRPCKeyID=' + pRPCKeyID;
    if (startDateString != null) {
      url += '&startDateString=' + startDateString;
    }
    if (endDateString != null) {
      url += '&endDateString=' + endDateString;
    }
    return this.http.get(url).toPromise();
  }

  getTemplateDays(crewTemplateID) {
    const url = '/CrewTimecard/GetTemplateDays?crewTemplateID=' + crewTemplateID;
    return this.http.get(url).toPromise();
  }

  getWeeks(pRPCKeyID) {
    const url = '/Timecard/GetWeeksByPRPCKeyID?pRPCKeyID=' + pRPCKeyID;
    return this.http.get(url).toPromise();
  }

  insertUpdateTime(
    pREHKeyID: number = null,
    pRPCKeyID: number,
    dateWorkedString: string,
    startTimeString: string,
    stopTimeString: string,
    seq: number,
    notes: string,
    employee?: number,
    breakHours?: any
  ) {
    const url = '/Timecard/InsertUpdateTime';
    return this.http
      .post(url, {
        pREHKeyID: pREHKeyID,
        pRPCKeyID: pRPCKeyID,
        dateWorkedString: dateWorkedString,
        startTimeString: startTimeString,
        stopTimeString: stopTimeString,
        seq: seq,
        notes: notes,
        employee: employee,
        breakHours: breakHours,
      })
      .toPromise();
  }

  deleteTime(pREHKeyID: number = null, pRPCKeyID: number, dateWorkedString: string, seq: number, employee?: number) {
    const url = '/Timecard/DeleteTime';
    return this.http
      .post(url, {
        pREHKeyID: pREHKeyID,
        pRPCKeyID: pRPCKeyID,
        dateWorkedString: dateWorkedString,
        seq: seq,
        employee: employee,
      })
      .toPromise();
  }
}
